export default {"src":"/_next/static/media/linkedin-icon.ed4d92df.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};